import FormTextBox from "../../micro_components/FormTextBox";
import Dropzone from "../../micro_components/DropZone";

export default function BookTitleAndCover({
  book,
  bookCoverLink,
  handleInputChange,
  setBookCover,
}) {
  const handleBookCoverSet = (data) => {
    setBookCover(data);
  };

  return (
    <div className="add-book-form__section title-and-cover">
      <div className="add-book-form__field">
        <FormTextBox
          value={book?.title}
          label="Book Title"
          initialValue={""}
          onChange={handleInputChange}
          name="title"
        />
      </div>
      {/* BOOK COVER */}
      <div className="add-book-form__field">
        <Dropzone
          originalFile={bookCoverLink}
          label={"Book Cover"}
          setFileData={handleBookCoverSet}
          width={246}
          height={330}
        />
      </div>
    </div>
  );
}
